import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick-theme.css";
import 'react-accessible-accordion/dist/fancy-example.css';
import "react-alice-carousel/lib/alice-carousel.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Developer } from './components/FaqPage/Developer'
import { Business } from './components/FaqPage/Business'
import { Billing } from './components/FaqPage/Billing'
import { Others } from './components/FaqPage/Others'
import { Support } from './components/FaqPage/Support'
import { PricingPlan } from './components/PricingPlan/PricingPlan'




ReactDOM.render(
  <React.StrictMode>
   <Router>
      {/* <Home/> */}

      <Routes>
      {/* <Route  path='/business' element={<Business/>} /> */}
      <Route  path='/faq/business' element={<Business/>} />
      <Route  path='/faq/billing' element={<Billing/>} />
      <Route  path='/faq' element={<Business/>} />
      <Route path='/faq/developer' element={<Developer/>} />
      <Route  path='/faq/others' element={<Others/>}     />
      <Route  path='/faq/support' element={<Support/>} />
      <Route  path='/pricing' element={<PricingPlan />} /> 
      <Route exact path="/" element={<App />} />


        </Routes>

        {/* <Routes>
          <Route path='/billing' element={<Billing/>} />
          <Route path='/others' element={<Others/>} />
          <Route path='/support' element={<Support/>} />

        </Routes> */}
      </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
